/*
 * @Author: AnNa
 * @Date: 2021-04-13 18:51:54
 * @LastEditors: AnNa
 * @LastEditTime: 2021-05-20 14:59:52
 * @Description: 
 */
const user = [
  17752930742,
  17732962011,
  18032780225
  // 18134178503,
  // 13463052171
]

export default user